import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const PersonasPage = loadAsyncComponent(() => import('./Container'), 'page');
